import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Table } from '@quintoandar-tokko/jopijs';
import LoadingMoreSkeleton from '../components/LoadingMoreSkeleton';
import ProductionRateTableRow from './ProductionRateTableRow';
import buildQuery from '../../utils/buildQuery';
import buildTableQuery from '../../utils/buildTableQuery';
import useObserver from '@/hooks/useObserver';
import { getPerformanceProductionRateTable } from '@/store/slices/components/dashboard/service';

export default function ProductionRateNonGroupedTableContent({ headers }) {
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const dispatch = useDispatch();
  const { productionRate } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );
  const { ref: loadMoreRef, isInViewport } = useObserver();

  useEffect(() => {
    if (!productionRate.has_next) return;
    if (!isInViewport || productionRate.loading) return;

    const query = buildQuery(selectedIds);
    const tableQuery = buildTableQuery(productionRate, {
      withNextPage: true,
    });

    dispatch(getPerformanceProductionRateTable({ query, tableQuery }));
  }, [isInViewport]);

  return (
    <Table.Rows>
      {productionRate.list.map((row, index) => (
        // eslint-disable-next-line
        <ProductionRateTableRow key={index} row={row} />
      ))}

      <Box as="tr" ref={loadMoreRef} style={{ height: 1, opacity: 0 }} />

      {(productionRate.loading || productionRate.has_next) && (
        <LoadingMoreSkeleton columns={headers.length} />
      )}
    </Table.Rows>
  );
}
